// External
import React from 'react';
import { ConnectedRouter } from 'react-router-redux'
import { Provider } from 'react-redux'
import {store, history } from './store/store'
import ThemeProvider from 'cxs/ThemeProvider'
import theme from './theme'
//// Internal
import Layout from './layout'
import { ToastContainer } from 'react-toastify';

import {hot} from 'react-hot-loader'

class App extends React.Component{
  render() {
    //return <div> hey </div>
    return (
        <Provider store={store}>
            <ConnectedRouter history={history} store={this.props.store} >
                <ThemeProvider theme={theme}>
                    <Layout/>
                    <ToastContainer/>
                </ThemeProvider>
            </ConnectedRouter>
        </Provider>
    );
  }
}

export default hot(module)(App)



// WEBPACK FOOTER //
// ./src/App.js